import React, { Component } from 'react';
import styled from 'styled-components';
import type { HelpPageQuery } from '@graphql/pages/help.generated';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import HelpSection from './HelpSection';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import { setWindowHash } from '../../../../lib/utils';
import { onCTAClick } from '../../../../lib/atm';

type HelpData = HelpPageQuery['helpPage'];
type Props = { displayName: string | null; helpPageData: HelpData };
type State = { selectedQuestions: Record<string, boolean> };

const TitleH1 = styled.h1`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}
  color: ${(p) => p.theme.c.text.primary};
  margin-top: ${(p) => p.theme.unit(8)};
`;

const SubHeaderDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${(p) => p.theme.c.text.primary};
  margin-top: ${(p) => p.theme.unit(2)};
  margin-bottom: ${(p) => p.theme.unit(6)};
  
  strong {
    font-weight: var(--typography-font-weight-bold);
  }
`;

class HelpPageContent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedQuestions: {},
    };
  }

  handleQuestionSelect = (sectionSlug: string, questionSlug: string, event: React.MouseEvent | React.KeyboardEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (('detail' in event && event.detail === 1)
      || ('key' in event && event.key === 'Enter')
      || ('charCode' in event && event.charCode === 32)) {
      this.setState(({ selectedQuestions }) => {
        const isOpeningAction = !selectedQuestions[questionSlug];
        if (isOpeningAction) onCTAClick(event);
        return { selectedQuestions: { ...selectedQuestions, [questionSlug]: isOpeningAction } };
      });
      setWindowHash(sectionSlug, questionSlug);
    }
  };

  render() {
    const {
      displayName = '',
      helpPageData,
    } = this.props;

    const helpSections = helpPageData?.helpSections?.filter((section) => section !== null) || [];
    const subHeaderText = helpPageData?.subHeaderText || '';
    const { selectedQuestions } = this.state;

    const createHelpSection = (isMobile: boolean) => helpSections.map((section) => (
      <HelpSection
        key={`help-section-${section.slug}`}
        isMobile={isMobile}
        helpSectionData={section}
        onQuestionSelect={this.handleQuestionSelect}
        selectedQuestions={selectedQuestions}
      />
    ));

    const subHeaderTextToRender = (
      <SubHeaderDiv dangerouslySetInnerHTML={{
        __html: subHeaderText,
      }}
      />
    );

    const desktopPage = (
      <MaxWidthLayout>
        <TitleH1>{ displayName }</TitleH1>
        { subHeaderTextToRender }
        { createHelpSection(false) }
      </MaxWidthLayout>
    );

    const mobilePage = (
      <MaxWidthLayout>
        <TitleH1>{ displayName }</TitleH1>
        { subHeaderTextToRender }
        { createHelpSection(true) }
      </MaxWidthLayout>
    );

    const renderComp = (
      <MediaQueryHelper
        desktopChildren={desktopPage}
        mobileChildren={mobilePage}
      />
    );

    return renderComp;
  }
}

export default HelpPageContent;
